import { Link } from 'react-router-dom';
import { useWindowSize } from 'usehooks-ts';
import { useBackendApi } from '../../helpers/backendHelper';
import { useGlobalState } from '../../state/GlobalStateProvider';
import Icons from '../icons/Icons';
import LoginButton from '../login/LoginButton';
import { useModal } from '../modal/ModalContext';
import { useTheme } from '../theme/Theme';
import './Navbar.scss';
import UserDropdown from './UserDropdown';

const Navbar = () => {
  const [theme, toggleTheme] = useTheme();
  const { width } = useWindowSize();
  const [{ openModal, closeModal }] = useModal();
  const [{ user }] = useGlobalState();
  const backendHelper = useBackendApi();

  const hamburgerClick = () => {
    openModal({
      className: 'Hamburger-container',
      content: (
        <>
          <Link to='/' onClick={closeModal}>
            <Icons icon={'home'} /> Home
          </Link>
          <Link to='/raffles' onClick={closeModal}>
            <Icons icon={'raffle'} /> Raffles
          </Link>
          <Link to='/mbadges' onClick={closeModal}>
            <Icons icon={'star'} /> MBadges
          </Link>
          {/* <Link to="/og-nft" onClick={closeModal}>
            <Icons icon={"star"} /> OG NFT
          </Link> */}
          <Link className='menu' to='/claim'>
            <Icons icon={'star'} /> Claim
          </Link>
          {/* <a href='https://mercle.xyz' target='_blank'>
            <Icons icon={'info'} /> About
          </a> */}
        </>
      ),
    });
  };
  async function getLink() {
    try {
      const url = window.location.href;
      console.log(url);
      let code = await backendHelper.user.getReferralCode(url);
      return `${window.location.host}/r/${code?.code}`;
    } catch (error) {
      console.log(error);
    }
  }

  //communityReferral !== null && (communityReferral || mercleReferral)

  return (
    <section className='Navbar-container'>
      <div></div>
      <div>{user && <LoginButton content={<UserDropdown />} />}</div>
    </section>
  );
};

export default Navbar;
